import { Injectable, inject } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetModuleLoading } from '@store/module-load.action';

@Injectable({
  providedIn: 'root'
})
export class RouteLoaderService {
  static ignoredRoute = 'auth';
  private store = inject(Store);

  public initialize(router: Router): void {
    router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart && this.isValidEvent(event)) {
        this.store.dispatch(new SetModuleLoading(true));
      } else if (event instanceof RouteConfigLoadEnd && this.isValidEvent(event)) {
        this.store.dispatch(new SetModuleLoading(false));
      }
    });
  }

  private isValidEvent(event: RouteConfigLoadStart | RouteConfigLoadEnd): boolean {
    return (event.route.path &&
      event.route.path.length > 0 &&
      event.route.path !== RouteLoaderService.ignoredRoute) ||
      false;
  }
}
